import React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import { linkTo } from 'env/utils/strings';

interface Props {
  page: number;
  totalPages: number;
}

export function PageLinks({ page, totalPages }: Props): JSX.Element | null {
  const { t } = useTranslation();
  const router = useRouter();

  if (totalPages <= 1) return null;

  return (
    <nav>
      <ul className="pagination">
        {page > 1 && (
          <>
            <li>
              <Link
                href={linkTo(router, { page: page - 1 })}
                className="btn prev"
                aria-label={t('Previous')}
              >
                <span aria-hidden="true">
                  <i className="icon-chevron-right"></i>
                </span>
              </Link>
            </li>
            {page > 2 && (
              <li>
                <Link href={linkTo(router, { page: 1 })} className="btn">
                  1
                </Link>
              </li>
            )}
            {page > 3 && (
              <li className="disabled">
                <a className="btn dots" href="#">
                  <span>...</span>
                </a>
              </li>
            )}
            <li>
              <Link href={linkTo(router, { page: page - 1 })} className="btn">
                {page - 1}
              </Link>
            </li>
          </>
        )}
        <li className="active">
          <a className="btn" href="#">
            {page} <span className="sr-only">({t('current')})</span>
          </a>
        </li>
        {page < totalPages && (
          <>
            <li>
              <Link href={linkTo(router, { page: page + 1 })} className="btn">
                {page + 1}
              </Link>
            </li>
            {page < totalPages - 1 && (
              <>
                <li className="disabled">
                  <a className="btn dots" href="#">
                    <span>...</span>
                  </a>
                </li>
                <li>
                  <Link
                    href={linkTo(router, { page: totalPages })}
                    className="btn"
                  >
                    {totalPages}
                  </Link>
                </li>
              </>
            )}
            <li>
              <Link
                href={linkTo(router, { page: page + 1 })}
                className="btn next"
                aria-label={t('Next')}
              >
                <span aria-hidden="true">
                  <i className="icon-chevron-right"></i>
                </span>
              </Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}
